// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"158":"80c82978","298":"56c51221","580":"0c8dff8d","780":"e304d344","800":"cae8a598","828":"caa3c9ef"}[chunkId] + ".chunk.css";
};